import { format } from "@hejdoktor/resx-compiler"
export { format }

export const R = {
	"Status_Ongoing": "I gang",
	"Status_ArrivedInPast": "Ankom for {0} siden",
	"AnonymousDisplayName": "Anonym"
}